"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utcPeriodHrMinToDateRanges = exports.insertUTCPeriodHrMinsIntoArray = exports.getUTCPeriodsForUtcRange = exports.shiftUTCPeriodHrMins = exports.shiftUTCDayMaskPeriodByMins = exports.shiftUTCDayPeriodByMins = exports.getDayMaskFromWeekRelativeUTCMins = exports.getRelativeUTCDayMaskEnd = exports.getRelativeUTCDayMaskStart = exports.utcPeriodOverlaps = exports.printUTCDayPeriod = exports.printUTimeslot = exports.printDateRange = exports.printHrDay = exports.getToMins = exports.getFromMins = void 0;
exports.utcPeriodGenerator = utcPeriodGenerator;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const lambda_1 = require("../lambda");
const iotv_v3_types_2 = require("@iotv/iotv-v3-types");
const core_services_1 = require("@iotv/core-services");
const millisecondOperations_1 = require("./millisecondOperations");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
/** get from period. NOT taking into account out of day utc_start_hour (>23) or mins ( >59) */
const getFromMins = ({ utc_start_hour, utc_start_min }) => utc_start_hour * iotv_v3_types_1.MINS_HR + utc_start_min;
exports.getFromMins = getFromMins;
const getToMins = (utcPeriodHrMins) => (0, exports.getFromMins)(utcPeriodHrMins) + utcPeriodHrMins.duration_mins;
exports.getToMins = getToMins;
/**
 * For display purposes, get the padded `HH:mm` string from hours and minutes (not UTS or locale aware)
 */
const printHrDay = (hr, min) => `${hr.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
exports.printHrDay = printHrDay;
/**
 * For debug and display purposes
 */
const printDateRange = (dr) => {
    const intl = {
        year: 'numeric',
        month: '2-digit',
        weekday: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };
    return `${(0, millisecondOperations_1.getNiceDate)(dr[0].valueOf(), intl)} -> ${(0, millisecondOperations_1.getNiceDate)(dr[1].valueOf(), intl)}`;
};
exports.printDateRange = printDateRange;
/**
 * For display purposes, get the padded `HH:mm` string from a `UTCPeriodHrMins` timeslot
 */
const printUTimeslot = (timeslot) => `${(0, exports.printHrDay)(timeslot.utc_start_hour, timeslot.utc_start_min)} (${timeslot.duration_mins}min)`;
exports.printUTimeslot = printUTimeslot;
/**
 * For display purposes, get padded `Day HH:mm` string from a `UTCPeriodHrMins` timeslot
 */
const printUTCDayPeriod = (p, short) => {
    const { p: { utc_start_hour: local_start_hour, utc_start_min: local_start_min }, utcDay, } = p;
    const day = (0, core_services_1.capitalize)((0, iotv_v3_types_1.getDayMaskDayFromDayNumber)(utcDay));
    const printDay = short ? day.substring(0, 3) : day;
    return `${printDay} ${(0, exports.printHrDay)(local_start_hour, local_start_min)}`;
};
exports.printUTCDayPeriod = printUTCDayPeriod;
/** returns true if period A and B overlap, taking into account either or both A and B spanning the day 6 to day 0 changeover  */
const utcPeriodOverlaps = ({ periodA, periodB }) => {
    const x1DayMinsStart = (0, exports.getRelativeUTCDayMaskStart)(periodA);
    const x1DayMinsEnd = (0, exports.getRelativeUTCDayMaskEnd)(periodA);
    const x2DayMinsStart = (0, exports.getRelativeUTCDayMaskStart)(periodB);
    const x2DayMinsEnd = (0, exports.getRelativeUTCDayMaskEnd)(periodB);
    const periodASlots = [];
    if (x1DayMinsEnd < x1DayMinsStart) {
        const firstPeriodA = [x1DayMinsStart, iotv_v3_types_1.MINS_WEEK];
        const secondPeriodA = [0, x1DayMinsEnd];
        debug && console.log(`Period A spans new week`, { firstPeriodA, secondPeriodA });
        periodASlots.push(firstPeriodA, secondPeriodA);
    }
    else {
        const origPeriodA = [x1DayMinsStart, x1DayMinsEnd];
        periodASlots.push(origPeriodA);
    }
    const periodBSlots = [];
    if (x2DayMinsEnd < x2DayMinsStart) {
        const firstPeriodB = [x2DayMinsStart, iotv_v3_types_1.MINS_WEEK];
        const secondPeriodB = [0, x2DayMinsEnd];
        debug && console.log(`Period B spans new week`, { firstPeriodB, secondPeriodB });
        periodBSlots.push(firstPeriodB, secondPeriodB);
    }
    else {
        const origPeriodB = [x2DayMinsStart, x2DayMinsEnd];
        periodBSlots.push(origPeriodB);
    }
    const totalOverlap = periodASlots.reduce((aAcc, aCurr) => {
        const totalBLevelOverlap = periodBSlots.reduce((bAcc, bCurr) => {
            const bLevelOverlep = (0, iotv_v3_types_1.getOverlapLength)([aCurr, bCurr]);
            debug && console.log(`BLevelOverlap`, { aCurr, bCurr }, bLevelOverlep);
            return bAcc + bLevelOverlep;
        }, 0);
        debug && console.log(`totalBLevelOverlap`, totalBLevelOverlap);
        return aAcc + totalBLevelOverlap;
    }, 0);
    debug && console.log('Total overlap ', totalOverlap);
    return totalOverlap !== 0;
};
exports.utcPeriodOverlaps = utcPeriodOverlaps;
/** return number of minutes from start of utc week for the start part of a period, given a utc week start day */
const getRelativeUTCDayMaskStart = ({ p, utcDay }) => {
    /** the minutes from start of 7 day period which may be more than on period ahead */
    const zeroAbsoluteStartMins = utcDay * iotv_v3_types_1.MINS_DAY + (0, exports.getFromMins)(p);
    /** the equivalent minutes in an arbitrary period */
    const zeroRelativeStartMins = zeroAbsoluteStartMins % iotv_v3_types_1.MINS_WEEK;
    return zeroRelativeStartMins;
};
exports.getRelativeUTCDayMaskStart = getRelativeUTCDayMaskStart;
/** return number of minutes from start of utc week for the end part of a period, given a utc week start day */
const getRelativeUTCDayMaskEnd = ({ p, utcDay }) => {
    const { duration_mins } = p;
    /** the minutes from start of 7 day period which may be more than on period ahead */
    const zeroAbsoluteEndMins = (0, exports.getRelativeUTCDayMaskStart)({ p, utcDay }) + duration_mins;
    /** the equivalent minutes in an arbitrary period */
    const zeroRelativeEndMins = zeroAbsoluteEndMins % iotv_v3_types_1.MINS_WEEK;
    return zeroRelativeEndMins;
};
exports.getRelativeUTCDayMaskEnd = getRelativeUTCDayMaskEnd;
/** given minutes from start of a utc week, return week day, hour and min with keys in a form which is DayMaskDefintion compatible */
const getDayMaskFromWeekRelativeUTCMins = (mins) => {
    const days = Math.floor(mins / iotv_v3_types_1.MINS_DAY);
    const dayNumber = days % 7;
    const remainingMinsA = mins - days * iotv_v3_types_1.MINS_DAY;
    const utcHour = Math.floor(remainingMinsA / iotv_v3_types_1.MINS_HR);
    const utcMin = (remainingMinsA - utcHour * iotv_v3_types_1.MINS_HR);
    const dayMaskDay = (0, iotv_v3_types_1.getDayMaskDayFromDayNumber)(dayNumber);
    return { dayMaskDay, utcHour, utcMin };
};
exports.getDayMaskFromWeekRelativeUTCMins = getDayMaskFromWeekRelativeUTCMins;
/** shift utcDayPeriod positively or negatively by shiftMins minutes. Use this to manipuate timeslots of an IEntityProgrammme */
const shiftUTCDayPeriodByMins = ({ utcPeriod, shiftMins }) => {
    const { p: { duration_mins }, } = utcPeriod;
    const relativeStartMins = (0, exports.getRelativeUTCDayMaskStart)(utcPeriod);
    const newRelativeStartMins = relativeStartMins + shiftMins;
    const { dayMaskDay, utcHour, utcMin } = (0, exports.getDayMaskFromWeekRelativeUTCMins)(newRelativeStartMins);
    return { utcDay: (0, iotv_v3_types_1.getDayNumberFromDayMaskKey)(dayMaskDay), p: { duration_mins, utc_start_hour: utcHour, utc_start_min: utcMin } };
};
exports.shiftUTCDayPeriodByMins = shiftUTCDayPeriodByMins;
/** shift full utcDayMaskPeriod positively or negatively by shiftMins minutes. Use this to shift a full dayMask plus duration, start hr and start min object */
const shiftUTCDayMaskPeriodByMins = ({ utcDayMaskPeriod, shiftMins }) => {
    const uTCDayPeriods = (0, iotv_v3_types_1.utcDayMaskPeriodToUtcDayPeriods)(utcDayMaskPeriod).map((utcPeriod) => (0, exports.shiftUTCDayPeriodByMins)({ utcPeriod, shiftMins }));
    return (0, iotv_v3_types_1.utcDayPeriodsToUtcDayMaskPeriod)(uTCDayPeriods);
};
exports.shiftUTCDayMaskPeriodByMins = shiftUTCDayMaskPeriodByMins;
/** shifts period by shiftMins, does NOT reset utc_start_hour to be relative to 0 if addition causes hr to be more than 23 */
const shiftUTCPeriodHrMins = (uTCPeriodHrMins, shiftMins) => {
    const duration_mins = uTCPeriodHrMins.duration_mins;
    const mins = (0, exports.getFromMins)(uTCPeriodHrMins);
    const shfitedMins = mins + shiftMins;
    const utc_start_hour = Math.floor(shfitedMins / iotv_v3_types_1.MINS_HR);
    const utc_start_min = shfitedMins - utc_start_hour * iotv_v3_types_1.MINS_HR;
    return {
        duration_mins,
        utc_start_hour,
        utc_start_min,
    };
};
exports.shiftUTCPeriodHrMins = shiftUTCPeriodHrMins;
function* utcPeriodGenerator({ start, duration_mins, max }) {
    const { utcHour: utc_start_hour, utcMin: utc_start_min } = start;
    let thisPeriod = { duration_mins, utc_start_hour, utc_start_min };
    let nextPeriod = (0, exports.shiftUTCPeriodHrMins)(thisPeriod, duration_mins);
    const maxPeriod = { duration_mins, utc_start_hour: max.utcHour, utc_start_min: max.utcMin };
    let err = null;
    do {
        try {
            yield thisPeriod;
            thisPeriod = nextPeriod;
            nextPeriod = (0, exports.shiftUTCPeriodHrMins)(nextPeriod, duration_mins);
        }
        catch (e) {
            err = e;
            console.log('Error in stateMutator', e.message);
        }
    } while (!err && (0, exports.getFromMins)(nextPeriod) <= (0, exports.getToMins)(maxPeriod));
}
const getUTCPeriodsForUtcRange = ({ start, duration_mins, max }) => {
    const arr = [];
    const periods = utcPeriodGenerator({ duration_mins, max, start });
    for (let next of periods) {
        arr.push(next);
    }
    return arr;
};
exports.getUTCPeriodsForUtcRange = getUTCPeriodsForUtcRange;
/** insert timeslot in timeslot array before next most immediate start timeslot, shifting those later by the duration of the inserted timeslot if the new timeslot would overlap the next otherwises
 * any shifted timeslots exceeding start times of 23:59 are removed
 */
const insertUTCPeriodHrMinsIntoArray = ({ newTimeslot, timeslots, insertBehavior }) => {
    const newTimeslotStart = (0, exports.getFromMins)(newTimeslot);
    const idx = timeslots.findIndex((t) => {
        const tStart = (0, exports.getFromMins)(t);
        return newTimeslotStart <= tStart;
    });
    if (insertBehavior === iotv_v3_types_2.InsertBehavior.SHIFT) {
        timeslots.splice(idx, 0, newTimeslot);
        for (let i = idx; i < timeslots.length; i++) {
            const last = timeslots.at(i - 1);
            const next = timeslots.at(i);
            if (last && next) {
                const overlapMins = (0, exports.getToMins)(last) - (0, exports.getFromMins)(next);
                const overlaps = overlapMins > 0;
                if (overlaps) {
                    timeslots[i] = (0, exports.shiftUTCPeriodHrMins)(next, overlapMins);
                }
            }
        }
    }
    else if (insertBehavior === iotv_v3_types_2.InsertBehavior.TRUNCATE) {
        const next = timeslots.at(idx);
        if (next) {
            const nextFrom = (0, exports.getFromMins)(next);
            const duration_mins = nextFrom - newTimeslotStart;
            timeslots.splice(idx, 0, { ...newTimeslot, duration_mins });
        }
    }
    const inDayTimeslots = timeslots.filter((t) => t.utc_start_hour < 24);
    return inDayTimeslots;
};
exports.insertUTCPeriodHrMinsIntoArray = insertUTCPeriodHrMinsIntoArray;
/** returns sorted array of date periods, sorted by start time, starting from relativeDate for one week cycle */
const utcPeriodHrMinToDateRanges = ({ relativeDate, utcPeriodHrMins, dayMask }) => {
    let unorderedDateRanges = [];
    const utcDay = relativeDate.getUTCDay();
    const { duration_mins, utc_start_hour, utc_start_min } = utcPeriodHrMins;
    const { sunday, monday, tuesday, wednesday, thursday, friday, saturday } = dayMask;
    /** Sunday = 0 */
    const CanonicalDayMask = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
    for (let absIdx = utcDay; absIdx < utcDay + CanonicalDayMask.length; absIdx++) {
        /** pick the day from the day mask via Canonical position in week */
        const relIdx = absIdx % CanonicalDayMask.length;
        const dayEnabled = CanonicalDayMask[relIdx];
        if (dayEnabled) {
            /** start from relative date and increment for 1 week */
            const sevenDayCycleIdx = absIdx - utcDay;
            const baseStart = new Date(relativeDate);
            baseStart.setUTCDate(baseStart.getUTCDate() + sevenDayCycleIdx);
            baseStart.setUTCHours(utc_start_hour, utc_start_min, 0, 0);
            const baseEnd = new Date(baseStart);
            baseEnd.setUTCMinutes(baseEnd.getUTCMinutes() + duration_mins);
            debug &&
                console.log({
                    absIdx,
                    day: Object.keys({ sunday, monday, tuesday, wednesday, thursday, friday, saturday })[relIdx],
                    relIdx,
                    dayEnabled,
                    start: baseStart.toUTCString(),
                    end: baseEnd.toUTCString(),
                });
            unorderedDateRanges.push([baseStart, baseEnd]);
        }
    }
    let sortedDateRanges = unorderedDateRanges
        .map((dateRange) => {
        return dateRange;
    })
        .sort((a, b) => (a.at(0) < b.at(0) ? -1 : 1));
    return sortedDateRanges;
};
exports.utcPeriodHrMinToDateRanges = utcPeriodHrMinToDateRanges;
